import { render, staticRenderFns } from "./VInvite.vue?vue&type=template&id=918b12f0&"
import script from "./VInvite.vue?vue&type=script&lang=ts&"
export * from "./VInvite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports